<template>
  <Photos year="2025" :min-date="1744070400" :max-date="1744329600" date-text="April 8&ndash;11" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
